import Link from "next/link";
import Image from "next/image";
import { ADS_HOME_HREF } from "@/helpers/ads";

/**
 * لوگوی ژومنت (jument-logo-fa) با برچسب «Ads» سمت چپِ لوگو، وسط‌چین عمودی.
 * دسکتاپ: لوگو ۱۵۰×۴۰ و Ads ۱۶؛ موبایل: ۹۰×۲۴ و Ads ۱۴.
 */
export default function AdsLogo({ className = "" }) {
    return (
        <Link
            href={ADS_HOME_HREF}
            aria-label="ژومنت Ads"
            className={`flex items-center gap-1 lg:gap-2 ${className}`}>
            <Image
                src="/images/ads/logo-fa.svg"
                unoptimized
                priority
                alt="لوگو ژومنت"
                width={150}
                height={40}
                className="h-6 w-[90px] lg:h-10 lg:w-[150px]"
            />
            <span className="text-sm font-bold leading-[22px] text-jmt-black lg:text-base lg:leading-6" aria-hidden="true">
                Ads
            </span>
        </Link>
    );
}
